module.exports = __webpack_public_path__ + "img/download-pdf2.7f1dde76.svg";